import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { getQueryParams, gTagTracking, serviceDown, trackEvent } from '../utils/UtilityFunctions'
import { useSelector } from 'react-redux';
import { postApi } from '../api/services';
import MainLoader from '../components/MainLoader';

const StartTest = () => {

  const navigate = useNavigate()
  const mainRef = useRef(null);
  const locale = useSelector((state) => state.language.langData);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('channel', 'alopexia-before-signup')
    // let params = getQueryParams(window.location.href)
    // console.log("params>>>", params);
    // if(params?.params?.gender && params.params.gender) {
    //   localStorage.setItem('gender', params.params.gender)
    //   addUser(params.params.gender)
    // } else {
    // }
    navigate('/selectgender')
    // else {
    //   localStorage.setItem('gender', 'male')
    // }
    
    // navigate('/tutorial')
    // navigate('/selectgender')
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      // Show button after scrolling 20% of div height
      const scrolledPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
      console.log("scrolledPercent", scrolledPercent);
      if (scrolledPercent > 10) {
        setShowFixedButton(true);
      } else {
        setShowFixedButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [])

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='startTestPage' ref={mainRef}>
        
      </div>
    </>
  )
}

export default StartTest